import * as ExpoCrypto from 'expo-crypto';

/** Cryptographically secure random bytes (web, iOS, Android). */
export function getSecureRandomBytes(byteCount: number): Uint8Array {
  return ExpoCrypto.getRandomBytes(byteCount);
}

/** Hex encoding of secure random bytes — safe for OAuth `state` and similar tokens. */
export function getSecureRandomHex(byteCount: number): string {
  return Array.from(getSecureRandomBytes(byteCount), (byte) =>
    byte.toString(16).padStart(2, '0'),
  ).join('');
}
